import { TAG } from "../constants";
import { AbTest, AbTestVariant } from "../types";
import { patientApi } from "./patientApi";

export const abTestsApi = patientApi.injectEndpoints({
  endpoints: (build) => ({
    getABTestVariant: build.query<AbTestVariant, string>({
      query: (name) => ({
        url: `/api/patient/experiments/${name}/variant`,
        method: "GET",
      }),
    }),
    getAbTests: build.query<AbTest[], string>({
      query: (productSlug) => ({
        url: `/api/patient/experiments`,
        method: "GET",
        params: { product_slug: productSlug },
      }),
      providesTags: [TAG.EXPERIMENTS],
    }),
  }),
});

export const { useGetABTestVariantQuery, useGetAbTestsQuery } = abTestsApi;
